// extracted by mini-css-extract-plugin
export default {"-large":"b6_PojkV48mWIBXkhZWY","container":"w5Ntvhi9mBit6F1UWkvK","arrow":"AwNyC1_cNwtp7VLD1Q4V"};